export class CreateProcess {
  ContactId;
  ServiceOrderId;

  constructor(contactId, serviceOrderId) {
    this.ContactId = contactId;
    this.ServiceOrderId = serviceOrderId;
  }
}
